import React, {
  useCallback,
} from 'react'

import PropTypes from 'prop-types'

import UINames from 'constants/ui-names'

import { useDisplayManager } from 'components/DisplayManager'


export default function ConsentMessage({ messageComponent: Component }) {
  const { pushActiveUI } = useDisplayManager()

  const handleShowDocument = useCallback((docUrl) => {
    pushActiveUI(UINames.DOC_MODAL, {
      docUrl,
    })
  }, [pushActiveUI])

  const handleShowPreferences = useCallback(() => {
    pushActiveUI(UINames.PREFERENCES)
  }, [pushActiveUI])

  return (
    <Component
      handleShowDocument={ handleShowDocument }
      handleShowPreferences={ handleShowPreferences }
    />
  )
}

ConsentMessage.propTypes = {
  messageComponent: PropTypes.elementType.isRequired,
}
